import React, { useState } from 'react';
import axios from 'axios';
import UserInfoForm from '../Forms/userinfoform';

function MyForm() {
  const [first, setFirst] = useState('');
  const [last, setLast] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');


  const handleSubmit = (event) => {
    event.preventDefault();

    axios.post('/api/users', { first, last, phone, email })
      .then(response => {
        console.log('User created:', response.data);
        // Reset form fields
        setFirst('');
        setLast('');
        setPhone('');
        setEmail('');
      })
      .catch(error => {
        console.error('Error creating user:', error);
      });
  };

  return (
    <>   
    <UserInfoForm />
    </>
  );
}

export default MyForm;